<template>
    <div>
        <v-container>
          <v-card style="background-color: #F5F5F5" elevation="3">
            <div class="mt-2 mb-5 text-h5 text-sm-h5 text-md-h4 text-lg-h4 ma-3 text-xl-h4 text-center">
                <span v-if="isNew">Nueva</span>
                <span v-if="!isNew">Editar</span>
                variante de material
            </div>

            <v-form
              ref="form"
              v-model="isValid"
              autocomplete="off">
              <v-tabs v-model="tab" background-color="transparent" show-arrows>
                  <v-tabs-slider color="blue"></v-tabs-slider>

                  <v-tab href="#tab-var">Variante</v-tab>
                  <v-tab href="#tab-emp">Empresas</v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab" touchless>
                  <v-tab-item :value="'tab-var'">
                      <v-card style="background-color: #F5F5F5" flat>
                          <!-- FORMULARIO VARIANTE -->
                          <v-row>
                              <v-col class="px-7 mt-4" cols="6" sm="3" md="3" lg="3" xl="2">
                                  <v-text-field
                                      outlined
                                      dense
                                      text
                                      hide-details
                                      v-model="matVar.MatVarCod"
                                      label="Código">
                                  </v-text-field>
                              </v-col>
                          </v-row>
                          <v-row>
                              <v-col class="px-7 mt-2" cols="12" sm="9" md="6" lg="6" xl="5">
                                  <v-text-field
                                      class="mb-n7"
                                      outlined
                                      dense
                                      text
                                      v-model="matVar.MatVarNom"
                                      required
                                      :rules="[v => !!v || 'El nombre es obligatorio']"
                                      label="Nombre *">
                                  </v-text-field>
                              </v-col>
                          </v-row>
                          <v-row>
                          <v-col class="px-7 mt-2" cols="12" sm="9" md="6" lg="6" xl="5">
                              <v-text-field
                                  outlined
                                  dense
                                  text
                                  hide-details
                                  :value="matVar.MatVarParent != null ? matVar.MatVarParent.MatVarNom : ''"
                                  tabindex="-1"
                                  readonly
                                  label="Tipo">
                              </v-text-field>
                          </v-col>
                      </v-row>
                          <v-row>
                              <v-col class="px-7 mt-2" cols="12" sm="8" md="6" lg="6" xl="5">
                                  <v-textarea
                                      class="mt-0"
                                      outlined
                                      dense
                                      hide-details
                                      auto-grow
                                      v-model="matVar.MatVarObs"
                                      label="Observaciones">
                                  </v-textarea>
                              </v-col>
                          </v-row>
                      </v-card>
                  </v-tab-item>
                  <v-tab-item :value="'tab-emp'" eager>
                      <v-card style="background-color: #F5F5F5" flat>
                          <!-- EMPRESAS -->
                          <v-row class="mt-0">
                              <v-col class="px-7" cols="12" sm="9" md="8" lg="7" xl="6">
                                  <EmpresasRelacionadas
                                      ref="relatedEmps"
                                      :empList="empDataList" 
                                      :empTotal="empDataTotal" 
                                      :loading="loading" 
                                      @update-data="updateEmpData">
                                  </EmpresasRelacionadas>
                              </v-col>
                          </v-row>
                      </v-card>
                  </v-tab-item>
              </v-tabs-items>

            <!-- ACEPTAR / CANCELAR / BORRAR -->
            <v-row class="mt-2" justify="center">
                <v-btn
                    :loading="loading"
                    :disabled="!isValid"
                    @click="onBtnSave"
                    color="primary"
                    class="mt-2 mb-4 mr-2"
                    style="width:100px">
                    Aceptar
                </v-btn>
                
                <v-btn
                    class="mt-2 mb-4 mr-2"
                    style="width:100px"
                    @click="goToList">
                    Cancelar
                </v-btn>

                <!-- && canDelete" -->
                <v-btn v-if="!isNew"
                    color="error"
                    class="mt-2 mb-4"
                    style="width:100px"
                    @click="onBtnShowDeleteModal">
                    Borrar
                </v-btn>
            </v-row>
            </v-form>
          </v-card>
        </v-container>

        <!-- Modales de borrado -->
        <!-- Borrar variante -->
        <v-dialog
            v-model="showDeleteDialog"
            transition="dialog-bottom-transition"
            persistent
            width="500">
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    BORRAR VARIANTE
                </v-card-title>

                <v-card-text class="mt-2">
                    ¿Desea borrar la variante? Esta acción no se podrá deshacer.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        :loading="loading"
                        color="primary"
                        @click="onBtnDelete">
                        Aceptar
                    </v-btn>
                    <v-btn @click="onBtnCancelDelete">
                        Cancelar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import EmpresasRelacionadas from "../components/EmpresasRelacionadas.vue";
export default ({
    components: {
        EmpresasRelacionadas
    },
    computed: {
        ...mapState(['empId', 'perId', 'urlRaiz'])
    },
    data () {
        return {
            tab: null,
            loading: false,
            isNew: true,
            isValid: false,
            showDeleteDialog: false,
            matVar: {
                MatVarId: 0,
                MatVarCod: '',
                MatVarNom: '',
                MatVarObs: '',
                MatVarParent: null,
                MatVarIdParent: null
            },
            // Datos tabla empresas
            empDataTotal: 0,
            empDataList: []
        }
    },
    // watch: {
    //   matVar: {
    //     handler () {
    //         this.validate();
    //     },
    //     deep: true,
    //   }
    // },
    mounted() {
      this.isNew = this.$route.meta.isNew;
      
      if(!this.isNew) {
        this.matVar.MatVarId = this.$route.params.id;
        this.loadData();
      } else {
        // Init MatVarParent
        if(this.$store.state.MatVarParentData != null) {
          this.matVar.MatVarParent = this.$store.state.MatVarParentData;
          this.matVar.MatVarIdParent = this.$store.state.MatVarParentData.MatVarId;
        }

        // Usar eager en la v-tab-item para poder tener la ref cargada
        this.$refs.relatedEmps.loadDefaultEmps();
      }
    },
    methods: {
      goToList() {
        this.$router.push('/variantes-material');
      },

      //#region Llamadas a la API
      getDataFromApi() {
        this.loading = true;
        return new Promise((resolve) => {
          const controllerParameters = {
            Action: 'GET_MATVAR',
            MatVarId: this.matVar.MatVarId,
            EmpId: this.empId
          };       
          const AuthToken = localStorage.getItem('token');
          axios({ method: "POST", "url": this.urlRaiz + "/api/matvar", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } })
          .then(result => {
            const item = result.data.MatVar;

            setTimeout(() => {
                this.loading = false;
                resolve({
                    item
                })
            }, 1000)
          })
          .catch(error => {
            if(error != null) {
                this.loading = false;
                alert('Error al cargar la variante.');
                this.goToList();
            }
          });
        })
      },
      postDataToApi() {
        this.loading = true;

        // Asignamos los IDs de los objetos hijos
        const empIds = this.empDataList.map(m => m.EmpId);

        return new Promise((resolve) => {
          const controllerParameters = {
            Action: 'SAVE_ENTITY',
            MatVar: this.matVar,
            EmpIds: empIds
          };
          const AuthToken = localStorage.getItem('token');
          axios({ method: "POST", "url": this.urlRaiz + "/api/matvar", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } })
          .then(result => {
            const item = result.data;

            setTimeout(() => {
                this.loading = false;
                resolve({
                    item
                })
            }, 1000)
          })
          .catch(error => {
            if(error != null) {
                this.loading = false;
                alert('Error al guardar la variante.');
            }
          });
        })
      },
      deleteDataFromApi() {
        this.loading = true;
        return new Promise((resolve) => {
          const controllerParameters = {
            Action: 'DEL_ENTITY',
            MatVarId: this.matVar.MatVarId
          };       
          const AuthToken = localStorage.getItem('token');
          axios({ method: "POST", "url": this.urlRaiz + "/api/matvar", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } })
          .then(result => {
            const item = result.data;

            setTimeout(() => {
                this.loading = false;
                resolve({
                    item
                })
            }, 1000)
          })
          .catch(error => {
            if(error != null) {
                this.loading = false;
                alert('Error al borrar la variante.');
            }
          });
        })
      },
      //#endregion

      //#region Carga de datos
      loadData() {
        this.getDataFromApi()
          .then(data => {
            if(data.item == null) {
              alert('Variante no encontrada.');
              this.goToList();
              return;
            }

            this.matVar = data.item;
            
            this.empDataTotal = data.item.MatVarEmp.length;
            this.empDataList = [];
            data.item.MatVarEmp.forEach(i => {
              this.empDataList.push({
                EmpId: i.Emp.EmpId,
                EmpNom: i.Emp.EmpNom
              });
            });
          });
      },
      //#endregion

      //#region Click guardado
      onBtnSave() {
          this.validate();
          if(!this.isValid) { return; }
          this.postDataToApi().then(data => {
            if(data.item.MatVarId != null) {
              this.goToList();
            }
            else {
              alert('Error al guardar la variante.');
            }
          });
      },
      //#endregion

      //#region Click borrar
      onBtnDelete() {
        this.deleteDataFromApi().then(data => {
          if (data.item.Success) {
            this.showDeleteDialog = false;
            this.goToList();
          }
          else {
            alert(data.item.Message);
          }
        });
      },
      //#endregion

      //#region Gestión de modales
      onBtnShowDeleteModal() {
        this.showDeleteDialog = true;
      },
      onBtnCancelDelete() {
        this.showDeleteDialog = false;
      },
      //#endregion

      //#region Evento actualización empresas
      updateEmpData(data) {
        this.empDataList = data.list;
        this.empDataTotal = data.total;
      },
      //#endregion

      //#region Validar formulario
      validate() {
          this.$refs.form.validate();
      }
      //#endregion
    } 
})
</script>
